<template>
    <SoliAvatarBtn
        v-if="location && room && online !== null"
        @click="$emit('input', location)"
        :title="`${location.name} | ${online ? 'Online' : room.title}`"
        icon="storefront"
        :subtitleBottom="online ? null : addressLineOne"
        :subtitleBottom2="addressLineTwo"
        blue
    >
    </SoliAvatarBtn>
</template>

<script>
export default {
    props: {
        location: {
            type: Object,
            default: () => {},
        },
        online: {
            type: Boolean,
            default: false,
        },
        room: {
            type: Object,
            default: () => {},
        },
        address: {
            type: String,
            default: null,
        },
    },
    computed: {
        addressLineOne() {
            if (!this.location) return null;
            let address = this.address ?? this.location.address;
            return address.split(",")[0];
        },
        addressLineTwo() {
            if (this.online || !this.location) return null;
            let address = this.address ?? this.location.address;
            let [line1, ...line2] = address.split(",");
            line2 = line2.join(",");
            return line2;
        },
    },
};
</script>

<style></style>
